module.exports = __webpack_public_path__ + "img/euro2020.3393800d.jpg";